module.exports = __webpack_public_path__ + "static/wedoit_graph-51ea71ea44bbd412c2cc434fc938a5e0.svg";